/**
 * @generated SignedSource<<76a9fc0a36bf731d75833f70cd415bff>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SystemStatsGranularity = "DAY" | "MONTH" | "%future added value";
export type useSystemGraphStatsRelayQuery$variables = {
  endDate?: any | null | undefined;
  granularity: SystemStatsGranularity;
  startDate?: any | null | undefined;
  systemId: string;
};
export type useSystemGraphStatsRelayQuery$data = {
  readonly systemStats: {
    readonly activeRentalsCount: number | null | undefined;
    readonly availableHardwareCount: number | null | undefined;
    readonly averageDurationByPeriod: ReadonlyArray<{
      readonly averageDuration: number;
      readonly period: string;
    }> | null | undefined;
    readonly rentalsByPeriod: ReadonlyArray<{
      readonly count: number;
      readonly period: string;
    }> | null | undefined;
    readonly rentalsCount: number | null | undefined;
    readonly usersByPeriod: ReadonlyArray<{
      readonly count: number;
      readonly period: string;
    }> | null | undefined;
    readonly usersCount: number | null | undefined;
  } | null | undefined;
};
export type useSystemGraphStatsRelayQuery = {
  response: useSystemGraphStatsRelayQuery$data;
  variables: useSystemGraphStatsRelayQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endDate"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "granularity"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startDate"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "systemId"
},
v4 = [
  {
    "kind": "Variable",
    "name": "endDate",
    "variableName": "endDate"
  },
  {
    "kind": "Variable",
    "name": "granularity",
    "variableName": "granularity"
  },
  {
    "kind": "Variable",
    "name": "startDate",
    "variableName": "startDate"
  },
  {
    "kind": "Variable",
    "name": "systemId",
    "variableName": "systemId"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "activeRentalsCount",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rentalsCount",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "usersCount",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "availableHardwareCount",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "period",
  "storageKey": null
},
v10 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "count",
    "storageKey": null
  },
  (v9/*: any*/)
],
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "SystemStatsPeriodStat",
  "kind": "LinkedField",
  "name": "rentalsByPeriod",
  "plural": true,
  "selections": (v10/*: any*/),
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "SystemStatsPeriodStat",
  "kind": "LinkedField",
  "name": "usersByPeriod",
  "plural": true,
  "selections": (v10/*: any*/),
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "SystemStatsDurationPeriodStat",
  "kind": "LinkedField",
  "name": "averageDurationByPeriod",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "averageDuration",
      "storageKey": null
    },
    (v9/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useSystemGraphStatsRelayQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "SystemStats",
        "kind": "LinkedField",
        "name": "systemStats",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "useSystemGraphStatsRelayQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "SystemStats",
        "kind": "LinkedField",
        "name": "systemStats",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "73d7f73c00f7458c2787874523522a8f",
    "id": null,
    "metadata": {},
    "name": "useSystemGraphStatsRelayQuery",
    "operationKind": "query",
    "text": "query useSystemGraphStatsRelayQuery(\n  $systemId: ID!\n  $startDate: DateTime\n  $endDate: DateTime\n  $granularity: SystemStatsGranularity!\n) {\n  systemStats(systemId: $systemId, startDate: $startDate, endDate: $endDate, granularity: $granularity) {\n    activeRentalsCount\n    rentalsCount\n    usersCount\n    availableHardwareCount\n    rentalsByPeriod {\n      count\n      period\n    }\n    usersByPeriod {\n      count\n      period\n    }\n    averageDurationByPeriod {\n      averageDuration\n      period\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "fb1ad3cb5887f650bed718e97131cf9b";

export default node;
